import { styled } from "styled-components";

interface IProps {
  version?: number | null;
}

const WarningContainer = styled.div`
  padding: 8px 24px;
  background-color: #ffdaa5;
  text-align: center;
`;

const Description = styled.div`
  font-family: "Roboto";
  font-style: "normal";
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #252525;
`;

export const InactiveRuleVersion = ({ version }: IProps) => {
  return (
    <WarningContainer>
      <Description>Aligned using rule version {version} (inactive)</Description>
    </WarningContainer>
  );
};
